import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import FaqQuestionCollapse from './FaqQuestionCollapse';
import Loader from '../../Components/Loader';
import Banner from '../../Components/Banner';
import styled from 'styled-components';
import ReactGA from 'react-ga4';
import { FaqType } from 'Components/Types';
import { FaqsAPI } from 'API/FaqsAPI';
import ErrorMessage from 'Components/ErrorMessage';

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 8em;
`;
const FaqContainer = styled.div`
    padding: 1em;
    margin: 2em;
    color: var(--main-teal-color);
`;

const Category = styled.p`
    font-family: Lato-Bold;
    font-size: 1.8em;
`;

function FaqsPage() {
    const [faqs, setFaqs] = useState<FaqType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [noFaqs, setNoFaqs] = useState<boolean>(false);
    const [categories, setCategories] = useState<string[]>([]);

    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });

    useEffect(() => {
        const getFaqs = async () => {
            setLoading(true);
            try {
                const response = await FaqsAPI.get();
                const uniqueCats = response
                    .map((faq: FaqType) => faq.category)
                    .filter(
                        (value: string, index: number, self: any) =>
                            self.indexOf(value) === index
                    );
                setCategories(uniqueCats);
                setFaqs(response);
            } catch {
                setNoFaqs(true);
            }
            setLoading(false);
        };
        getFaqs();
    }, []);

    return (
        <>
            <Banner mainText="FAQs" bodyText="View all our FAQs..." />
            <Container>
                {loading ? (
                    <LoaderContainer>
                        <Loader />
                    </LoaderContainer>
                ) : (
                    <>
                        {noFaqs ? (
                            <ErrorMessage />
                        ) : (
                            categories.map((faqCategory) => {
                                return (
                                    <FaqContainer key={faqCategory}>
                                        <Category>{faqCategory}</Category>
                                        {/*}For every category show every faq question and answer{*/}
                                        {faqs
                                            .filter(
                                                (faq) =>
                                                    faq.category === faqCategory
                                            )
                                            .map((faq) => {
                                                return (
                                                    <FaqQuestionCollapse
                                                        key={faq.faq_id}
                                                        question={faq.question}
                                                        answer={faq.answer}
                                                    />
                                                );
                                            })}
                                    </FaqContainer>
                                );
                            })
                        )}
                    </>
                )}
            </Container>
        </>
    );
}
export default FaqsPage;
